<template>
  <b-modal
    v-model="dataModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    title="Add Tasks"
    @close="onCloseModal">
    <div>
      <div class="upload__title">
        Players List
      </div>
      <call-uploader @on-files="onFiles" />
    </div>
    <template #modal-footer>
      <call-button
        :icon="dataCloseIcon"
        type="danger"
        plain
        @click="onCloseModal()">
        Cancel
      </call-button>
      <call-button
        :icon="dataAddIcon"
        :disabled="computedEmptyFiles"
        type="success"
        @click="clickAdd()">
        Add tasks
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import CallButton from '../CallButton';
import { PROJECTS_CREATE_TASKS_LIST } from '../../../store/types/actions.types';
import iconsModal from '../../../mixins/iconsModal';
import CallUploader from '../../desktop/CallUploader';
import helper from '../../../service/helper';
import { Notify } from 'vant';
import Vue from 'vue';
import Notification from '../../../components/common/notification';

export default {
  name: 'CallModalAddTasks',
  components: {
    CallUploader,
    CallButton,
    BModal
  },
  mixins: [iconsModal],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      dataModal: this.value,
      dataForm: {
        files: null
      }
    };
  },
  computed: {
    computedEmptyFiles () {
      return helper.isEmpty(this.dataForm, 'files');
    }
  },
  watch: {
    async value () {
      this.dataModal = this.value;
      if (this.dataModal) {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    }
  },
  methods: {
    onCloseModal () {
      this.$emit('input', false);
    },
    onFiles (files) {
      if (files.length === 0) {
        this.dataForm.files = null;
        return;
      }
      this.dataForm.files = files[0];
    },
    async clickAdd () {
      const formData = new FormData();
      if (this.dataForm.files) {
        formData.append('file', this.dataForm.files);
      }
      try {
        await this.$store.dispatch(`project/${PROJECTS_CREATE_TASKS_LIST}`, {
          params: formData,
          projectId: this.projectId
        });
        this.onCloseModal();
        this.$emit('on-update');
      } catch (e) {
        if (Vue.$device.mobile) {
          Notify({ type: 'danger', message: `${e?.message}` });
        } else {
          Notification({
            message: `${e?.message}`,
            type: 'error'
          });
        }
        throw Error(e);
      }
    }
  }
};
</script>
